var map = {
	"./Awards/21/Award.jpg": "2876",
	"./Awards/21/Thumb/Award.jpg": "af74",
	"./Awards/22/Thumb/TopCreativeLeaderBillboard.jpg": "d55f",
	"./Awards/22/TopCreativeLeaderBillboard.jpg": "55f7",
	"./Awards/23/MedalOfHonour.jpg": "cda5",
	"./Awards/23/Thumb/MedalOfHonour.jpg": "b2c4",
	"./Awards/24/Award.jpg": "41ff",
	"./Awards/24/Thumb/Award.jpg": "e153",
	"./Awards/25/Billboard.jpg": "2720",
	"./Awards/25/Billboard2.jpg": "543b",
	"./Awards/25/Billboard3.jpg": "8518",
	"./Awards/25/Thumb/Billboards.jpg": "cd09",
	"./Awards/26/HonoraryDoctorateEducation.jpg": "a9c7",
	"./Awards/26/Thumb/HonoraryDoctorateEducation.jpg": "b1b6",
	"./Awards/27/Award.jpg": "5d9b",
	"./Awards/27/Thumb/Award.jpg": "e342",
	"./Awards/28/Award.jpg": "0e10",
	"./Awards/28/Thumb/Award.jpg": "f47a",
	"./Awards/29/Award.jpg": "95fb",
	"./Awards/29/Thumb/Award.jpg": "c5a7",
	"./Awards/30/Thumb/TopCreativeLeader.jpg": "25a0",
	"./Awards/30/TopCreativeLeader.jpg": "2300",
	"./Awards/31/Award.jpg": "32c1",
	"./Awards/31/Thumb/Award.jpg": "35cb",
	"./Awards/32/Award.png": "be35",
	"./Awards/32/Award2.jpg": "b4ae",
	"./Awards/32/PanelInterpretingAcademicInterests.jpg": "89a3",
	"./Awards/32/Thumb/ExcellenceInEducation.jpg": "2b75",
	"./Awards/33/SealOfRecognition.png": "e12d",
	"./Awards/33/Thumb/ExcellenceInEducationSealOfRecognition.jpg": "269e",
	"./Awards/35/Thumb/TopExpert.jpg": "9234",
	"./Awards/35/TopExpert.jpg": "dcf2",
	"./Awards/36/Award.jpg": "802a",
	"./Awards/36/Thumb/Trophy.jpg": "bf67",
	"./Awards/37/Award.jpg": "f96e",
	"./Awards/37/Thumb/Trophy.jpg": "8a9f",
	"./Awards/38/BestOfQuarterDigitalIdentityDesign.jpg": "4b9d",
	"./Awards/38/Thumb/BestOfQuarterDigitalIdentityDesign.jpg": "2589",
	"./Awards/39/BestOfQuarterIntermediateAuthoring.jpg": "c7fd",
	"./Awards/39/Thumb/BestOfQuarterIntermediateAuthoring.jpg": "18ad",
	"./Awards/40/BestOfQuarterIntermediateWebDesign.jpg": "a691",
	"./Awards/40/Thumb/BestOfQuarterIntermediateWebDesign.jpg": "4160",
	"./Awards/41/BestOfQuarterDigitalIllustration.jpg": "88d6",
	"./Awards/41/Thumb/BestOfQuarterDigitalIllustration.jpg": "c06c",
	"./Awards/84/ThoughtLeadershipContributor.jpg": "0d97",
	"./Awards/84/Thumb/ThoughtLeadershipContributor.jpg": "f7e4",
	"./Awards/CIOToday/Trophy.jpg": "bdb6",
	"./Awards/CToday/Award.jpg": "c11f",
	"./Awards/Education2.0/ExcellenceInEducation.jpg": "db18",
	"./Awards/Education2.0/ExcellenceInEducationBanner.jpg": "5811",
	"./Awards/Education2.0/ExcellenceInEducationSealOfRecognition.jpg": "bd12",
	"./Awards/FluxxEvents/Award.jpg": "c0ac",
	"./Awards/FutureBillionaire/Award.jpg": "5ec0",
	"./Awards/IAOTP/TopCreativeLeader.jpg": "38be",
	"./Awards/IAOTP/TopCreativeLeaderBillboard.jpg": "ff1a",
	"./Awards/IAOTP/Trophy.jpg": "2d73",
	"./Awards/INOBAL/TopExpert.jpg": "6e21",
	"./Awards/InsightsSuccess/Trophy.jpg": "8abe",
	"./Awards/PassionVista/Trophy.jpg": "1ee7",
	"./Awards/TheForttunaGroup/Billboards.jpg": "43cf",
	"./Awards/TopGlobalRecognition/Award.jpg": "9d35",
	"./Awards/WPDO/MedalOfHonour.jpg": "4feb",
	"./Certificates/42/Certificate.jpg": "5b9b",
	"./Certificates/42/Thumb/Certificate.jpg": "ec44",
	"./Certificates/43/Certificate.jpg": "e375",
	"./Certificates/43/Thumb/Certificate.jpg": "0632",
	"./Certificates/44/Certificate.jpg": "3d61",
	"./Certificates/44/Thumb/Certificate.jpg": "7337",
	"./Certificates/45/Certificate.jpg": "ce3f",
	"./Certificates/45/Thumb/Certificate.jpg": "d0d0",
	"./Certificates/46/Certificate.jpg": "85ed",
	"./Certificates/46/Thumb/Certificate.jpg": "66ee",
	"./Certificates/47/Certificate.jpg": "73e7",
	"./Certificates/47/Thumb/Certificate.jpg": "72f1",
	"./Certificates/48/Certificate.jpg": "11e2",
	"./Certificates/48/Thumb/Certificate.jpg": "7ab8",
	"./Certificates/49/Certificate.jpg": "b745",
	"./Certificates/49/Thumb/Certificate.jpg": "9972",
	"./Certificates/50/Certificate.jpg": "9ab7",
	"./Certificates/50/Thumb/Certificate.jpg": "ecdd",
	"./Certificates/51/Certificate.jpg": "d23c",
	"./Certificates/51/Thumb/Certificate.jpg": "b97d",
	"./Certificates/52/Certificate.jpg": "1aa5",
	"./Certificates/52/Thumb/Certificate.jpg": "382f",
	"./Certificates/53/Certificate.jpg": "68db",
	"./Certificates/53/Thumb/Certificate.jpg": "2962",
	"./Certificates/54/Certificate.jpg": "50ef",
	"./Certificates/54/Thumb/Certificate.jpg": "c038",
	"./Certificates/55/Certificate.jpg": "c345",
	"./Certificates/55/Thumb/Certificate.jpg": "28cc",
	"./Certificates/56/CertificateOfParticipation.jpg": "7ab5",
	"./Certificates/56/Thumb/CertificateOfParticipation.jpg": "6132",
	"./Certificates/57/Certificate.jpg": "e420",
	"./Certificates/57/Thumb/Certificate.jpg": "8e86",
	"./Certificates/58/DSWTrainingPart1.jpg": "52dd",
	"./Certificates/58/Thumb/DSWTrainingPart1.jpg": "1857",
	"./Certificates/59/DSWTrainingPart2.jpg": "e656",
	"./Certificates/59/Thumb/DSWTrainingPart2.jpg": "23ca",
	"./Certificates/60/ThreatManagementFacingImminentDanger.jpg": "1c95",
	"./Certificates/60/Thumb/ThreatManagementFacingImminentDanger.jpg": "9e94",
	"./Certificates/61/LosAngelesCountyFair.jpg": "e841",
	"./Certificates/61/Thumb/LosAngelesCountyFair.jpg": "573f",
	"./Certificates/62/2024CountywidePrivacyAwarenessTraining.jpg": "3173",
	"./Certificates/62/Thumb/2024CountywidePrivacyAwarenessTraining.jpg": "8660",
	"./Certificates/63/PrivacyAwarenessCurriculum2023.jpg": "272a",
	"./Certificates/63/Thumb/PrivacyAwarenessCurriculum2023.jpg": "e525",
	"./Certificates/64/PrivacyAwarenessTraining.jpg": "afdb",
	"./Certificates/64/Thumb/PrivacyAwarenessTraining.jpg": "83b3",
	"./Certificates/65/CybersecurityAwarenessCurriculum2024.jpg": "65e7",
	"./Certificates/65/Thumb/CybersecurityAwarenessCurriculum2024.jpg": "d1ce",
	"./Certificates/66/CybersecurityAwarenessCurriculum2023.jpg": "81e9",
	"./Certificates/66/Thumb/CybersecurityAwarenessCurriculum2023.jpg": "ef47",
	"./Certificates/67/CybersecurityAwareness2022.jpg": "5838",
	"./Certificates/67/Thumb/CybersecurityAwareness2022.jpg": "cccc",
	"./Certificates/68/CyberHeroesSeriesInternetThreats.jpg": "bf9a",
	"./Certificates/68/Thumb/CyberHeroesSeriesInternetThreats.jpg": "a4f8",
	"./Certificates/69/CyberHeroesSeriesSocialMediaFever.jpg": "91cf",
	"./Certificates/69/Thumb/CyberHeroesSeriesSocialMediaFever.jpg": "1bb6",
	"./Certificates/70/InsiderThreat.jpg": "a344",
	"./Certificates/70/Thumb/InsiderThreat.jpg": "78f1",
	"./Certificates/71/2020SecurityAwarenessTraining.jpg": "ebaf",
	"./Certificates/71/Thumb/2020SecurityAwarenessTraining.jpg": "6ad8",
	"./Certificates/72/PasswordCollection.jpg": "d469",
	"./Certificates/72/Thumb/PasswordCollection.jpg": "f17a",
	"./Certificates/73/RestrictedIntelligence.jpg": "3af9",
	"./Certificates/73/Thumb/RestrictedIntelligence.jpg": "e495",
	"./Certificates/74/SafeguardingInformation.jpg": "7bb7",
	"./Certificates/74/Thumb/SafeguardingInformation.jpg": "a5a0",
	"./Certificates/75/Thumb/WhatIsPII.jpg": "3891",
	"./Certificates/75/WhatIsPII.jpg": "a16c",
	"./Certificates/76/ProtectingData.jpg": "c8f1",
	"./Certificates/76/Thumb/ProtectingData.jpg": "e4f8",
	"./Certificates/77/DiscoveringYourStrengths.jpg": "85a3",
	"./Certificates/77/Thumb/DiscoveringYourStrengths.jpg": "cc53",
	"./Certificates/78/EmergingLeaders.jpg": "0cf1",
	"./Certificates/78/Thumb/EmergingLeaders.jpg": "f1c6",
	"./Certificates/79/HandsOnlyCPRTrainingPart2.jpg": "d505",
	"./Certificates/79/Thumb/HandsOnlyCPRTrainingPart2.jpg": "2ce1",
	"./Certificates/80/ProcessImprovement2.jpg": "e355",
	"./Certificates/80/Thumb/ProcessImprovement2.jpg": "e5ca",
	"./Certificates/81/ProcessImprovement1.jpg": "a6a5",
	"./Certificates/81/Thumb/ProcessImprovement1.jpg": "707f",
	"./Certificates/82/LSSGreenBelt.jpg": "ab71",
	"./Certificates/82/Thumb/LSSGreenBelt.jpg": "6268",
	"./Certificates/83/LSSYellowBelt.jpg": "f282",
	"./Certificates/83/Thumb/LSSYellowBelt.jpg": "6107",
	"./Certificates/85/ThoughtLeadershipContributor.jpg": "6501",
	"./Certificates/85/Thumb/Certificate.jpg": "e490",
	"./Certificates/AmericanLeaders/Certificate.jpg": "3d40",
	"./Certificates/BusinessFoster/Certificate.jpg": "0d9b",
	"./Certificates/CEOVision/Certificate.jpg": "d85b",
	"./Certificates/CIOGlobal/Certificate.jpg": "90f0",
	"./Certificates/CIOToday/Certificate.jpg": "1971",
	"./Certificates/CToday/Certificate.jpg": "2059",
	"./Certificates/Education2.0/CertificateOfParticipation.jpg": "4021",
	"./Certificates/EliteEducation/Certificate.jpg": "3d9f",
	"./Certificates/FutureBillionaire/Certificate.jpg": "a783",
	"./Certificates/INOBAL/Certificate.jpg": "bb01",
	"./Certificates/LACRRCCBLTP/Certificate.jpg": "ae16",
	"./Certificates/PassionVista/Certificate.jpg": "9b59",
	"./Certificates/TheEducationLeaders/Certificate.jpg": "83a1",
	"./Certificates/TheEducationView/Certificate.jpg": "e9a6",
	"./Certificates/TheForttunaGroup/Certificate.jpg": "82fa",
	"./Certificates/WPDO/Certificate.jpg": "2c77",
	"./Features/1/Thumb/Xraised.jpg": "36da",
	"./Features/1/Xraised.jpg": "0fe3",
	"./Features/10/AmericanLeaders.jpg": "fff0",
	"./Features/10/Thumb/AmericanLeaders.jpg": "2f93",
	"./Features/11/CEOVision.jpg": "ed28",
	"./Features/11/RedefiningEducationalExcellence.jpg": "5916",
	"./Features/11/Thumb/CEOVision.jpg": "39e4",
	"./Features/12/Article.jpg": "0669",
	"./Features/12/CIOGlobal.jpg": "1dc6",
	"./Features/12/Thumb/CIOGlobal.jpg": "1488",
	"./Features/13/CIOToday.jpg": "f987",
	"./Features/13/CoverStory.jpg": "3eba",
	"./Features/13/Thumb/CIOToday.jpg": "6f46",
	"./Features/14/CoverStory.jpg": "a3a8",
	"./Features/14/TheEducationLeaders.jpg": "9312",
	"./Features/14/Thumb/TheEducationLeaders.jpg": "1f28",
	"./Features/15/CToday.jpg": "205a",
	"./Features/15/Thumb/CToday.jpg": "c987",
	"./Features/16/PressReleasesCover.jpg": "b28f",
	"./Features/16/Thumb/TopCreativeLeaderOfTheYear.jpg": "ccfa",
	"./Features/16/TopCreativeLeaderOfTheYear.jpg": "d0a5",
	"./Features/17/TheEducationView.jpg": "5b70",
	"./Features/17/Thumb/TheEducationView.jpg": "e01a",
	"./Features/18/INOBAL.jpg": "382c",
	"./Features/18/Thumb/INOBAL.jpg": "2916",
	"./Features/19/CoverStory.jpg": "407e",
	"./Features/19/InsightsSuccess.jpg": "10b5",
	"./Features/19/Thumb/InsightsSuccess.jpg": "5fe4",
	"./Features/2/FutureBillionaire.jpg": "3584",
	"./Features/2/Thumb/FutureBillionaire.jpg": "e2f3",
	"./Features/20/PassionVista.jpg": "e1d3",
	"./Features/20/Thumb/PassionVista.jpg": "d734",
	"./Features/3/Thumb/WorthMinds.jpg": "f24f",
	"./Features/3/WorthMinds.jpg": "4e17",
	"./Features/4/InternationalBusinessTimes.jpg": "7668",
	"./Features/4/Thumb/InternationalBusinessTimes.jpg": "92d6",
	"./Features/5/ForbesIndia.jpg": "7e3b",
	"./Features/5/Thumb/ForbesIndia.jpg": "ac07",
	"./Features/6/TheForttunaGroup.jpg": "721e",
	"./Features/6/Thumb/TheForttunaGroup.jpg": "e7d5",
	"./Features/7/EliteEducation.jpg": "46e9",
	"./Features/7/Thumb/EliteEducation.jpg": "6633",
	"./Features/8/BusinessFoster.jpg": "ae8d",
	"./Features/8/CoverStory.jpg": "ff3b",
	"./Features/8/Thumb/BusinessFoster.jpg": "5bdd",
	"./Features/87/IAOTP.jpg": "24f4",
	"./Features/87/Thumb/IAOTP.jpg": "9245",
	"./Features/9/Empire.jpg": "e175",
	"./Features/9/Thumb/Empire.jpg": "a7ff"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "238a";